import { buildClientDetails } from '@/helpers/taskcards/clientdetailsbuilder'
import { buildIdentityVerification } from '@/helpers/taskcards/identityverificationbuilder'
import { buildContractSigning } from '@/helpers/taskcards/contractsigningbuilder'
import { buildPreEngagementQuestionnaire } from '@/helpers/taskcards/preengagementquestionnairebuilder'
import { buildDirectDebitMandate } from '@/helpers/taskcards/directdebitmandatebuilder'
import { buildPreSlaRequirementsAgreement } from '@/helpers/taskcards/preslarequirementsagreementbuilder'
import { buildFileCollection } from '@/helpers/taskcards/filecollectionbuilder'
import { buildFileMapping } from '@/helpers/taskcards/filemappingbuilder'
import { buildDataUpload } from '@/helpers/taskcards/datacollectionbuilder'
import { buildDataSampleCollection } from '@/helpers/taskcards/internaltasks/datasamplecollectionbuilder'
import { buildMigration } from '@/helpers/taskcards/internaltasks/migrationbuilder'
import { buildParallelRun } from '@/helpers/taskcards/internaltasks/parallelrunbuilder'
import { buildPayrollHandover } from '@/helpers/taskcards/internaltasks/payrollhandover'
import { buildGoLive } from '@/helpers/taskcards/internaltasks/golivebuilder'


export function getBuilders() {
  return [
    { type: 'ClientDetails', execute: buildClientDetails },
    { type: 'IdentityVerificationContainer', execute: buildIdentityVerification },
    { type: 'ServiceLevelAgreement', execute: buildContractSigning },
    { type: 'PreDiscoveryChecklist', execute: buildPreEngagementQuestionnaire },

    { type: 'DiscoveryDataCollectionContainer', execute: buildDataUpload },

    { type: 'PreSlaRequirementsAgreement', execute: buildPreSlaRequirementsAgreement },
    { type: 'DirectDebitMandate', execute: buildDirectDebitMandate },

    { type: 'FileCollectionContainer', execute: buildFileCollection },
    { type: 'FileMapping', execute: buildFileMapping },

    { type: 'DataSampleCollection', execute: buildDataSampleCollection },
    { type: 'Migration', execute: buildMigration },
    { type: 'ParallelRun', execute: buildParallelRun },
    { type: 'PayrollHandover', execute: buildPayrollHandover },
    { type: 'GoLive', execute: buildGoLive }

  ];
}